import {DynamicColumnTable} from '@/components/organisms';
import {useQuery} from '@tanstack/react-query';
import {request} from '@/helpers/apiClient';

export const DisplayDynamicTable = () => {
  //  npx json-server  -p 3001 ./src/components/organisms/DynamicColumnTable/table-info.json
  const {
    data: rowData,
    isLoading: isDataLoading,
    isError: isDataError
  } = useQuery({
    queryKey: ['rowData'],
    queryFn: async () => {
      const data = await request({
        url: 'http://localhost:3001/data',
        method: 'GET'
      });
      return data;
    }
  });

  const {
    data: colConfig,
    isLoading: isColLoading,
    isError: isColError
  } = useQuery({
    queryKey: ['colConfig'],
    queryFn: async () => {
      const data = await request({
        url: 'http://localhost:3001/config',
        method: 'GET'
      });
      return data;
    }
  });

  if (isColError || isDataError) {
    return 'Error Loading the data from API';
  }

  if (isColLoading || isDataLoading) {
    return 'Loading Table Data ';
  }

  return (
    <DynamicColumnTable
      pklass='dynamic-table'
      columns={colConfig || []}
      records={rowData || []}
      isExpandable={false}
      tableDescription=''
      tableHeader=''
      pageIndex={0}
      pageSize={10}
      selection={'multiple'}
      isDark={true}
      isResizable={true}
      onUpdate={() => {}}
      toolbarActions={[
        {
          text: 'Download',
          variant: 'primary',
          onClick: () => {}
        }
      ]}
    />
  );
};

DisplayDynamicTable.propTypes = {
  // This component doesn't accept props as it manages its own state internally
  // PropTypes are defined here for documentation purposes but won't be enforced
};
